export const getEnvName = env => {
	if (/^dev/i.test(env || "local")) return "development";
	return env;
};
